'use client';

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchResponse } from '@/apiTypes/types';
import NonIdealState from '@/components/ui/NonIdealState';
import SearchPersonsContent from '@/components/search/scope/SearchPersonsContent';
import { searchNoResultImage } from '@/lib/helpers/hardcodedImages';

interface IProps {
  results: SearchResponse['persons'];
  query?: string;
}

export const PersonSearch: React.FC<IProps> = ({ results, query }) => {
  const { t } = useTranslation();
  const searchTerm = query?.length ? ` “${query}”` : '';
  if (results.items.length === 0) {
    return (
      <NonIdealState
        layout="horizontal"
        title={t('components.search.noPersonResults', { query: searchTerm })}
        imageUrl={searchNoResultImage()}
      />
    );
  }
  return (
    <SearchPersonsContent
      items={results.items}
      pagination={results.pagination}
    />
  );
};
